import { Component } from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent {
  constructor(private route: ActivatedRoute, private router: Router) {}

  scrollTo(elementId: string, page: string) {
    const currentPage = this.route.snapshot.url[0]?.path || '';
    console.log('currentPage', currentPage);

    if (currentPage !== page) {
      this.router.navigate([page]);
    }

    setTimeout(() => {
      const element = document.getElementById(elementId) as HTMLElement;
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest',
      });
    }, 250);
  }

  openMyMenu(menuTrigger: MatMenuTrigger) {
    menuTrigger.openMenu();
  }

  closeMyMenu(menuTrigger: MatMenuTrigger) {
    menuTrigger.closeMenu();
  }
}
